import React, { Component } from 'react';
import config from '../../config';
import Helmet from 'react-helmet';
// import Icon from 'components/Icon/Icon';

export default class Copyright extends Component {
  render() {
    return (
      <div className="container">
        <Helmet
          title="Copyright"
          link={[{ rel: 'canonical', href: config.baseUrl + '/copyright' }]}
        />

        <h1 className="lato-bold text-uppercase text-center aside-text mt mb">
          Copyright Policy
        </h1>

        <div className="panel p++">
          <p className="lato-regular mb+ mt+">
            Twine respects the intellectual property of others, and we ask our
            users to do the same. Each user is responsible for ensuring that the
            materials they upload to Twine do not infringe any third party
            copyright. Please read our <a href="/terms">Terms and Conditions</a>{' '}
            and <a href="/aup">Acceptable Use Policy</a> for more information.
          </p>

          <h3 className="lato-bold mt mb">
            Filing a Notice to Remove Copyrighted Content-for Copyright Holders
          </h3>

          <p className="lato-regular">
            If you believe some Content on Twine is your copyright protected
            work which has been posted without your authorization, you may
            submit a copyright infringement notification. These requests should
            only be submitted by the copyright owner or an agent authorized to
            act on the owner's behalf.
          </p>

          <p className="lato-regular">
            <strong>
              The easiest way to notify Twine of any alleged copyright
              infringement is
              {/* via our webform:</strong>
          </p>

          <p className="mb++ mt++ text-center">
            <a className="btn btn-primary btn-lg" href="/copyright/report">
              <Icon icon="&#xf02d;" /> Report copyright infringement
            </a>
          </p>

          <p className="lato-regular">
            You may also contact us*/}{' '}
              by e-mail or by traditional mail. Provide us with a written notice
              containing the following information:
            </strong>
          </p>

          <ol>
            <li>
              <p className="lato-regular">
                Your name, address, telephone number, and email address.
              </p>
            </li>
            <li>
              <p className="lato-regular">
                A description of the copyrighted work that you claim has been
                infringed.
              </p>
            </li>
            <li>
              <p className="lato-regular">
                A description of where on Twine the material that you claim is
                infringing may be found, sufficient for Twine to locate the
                infringing material (e.g., the URL).
              </p>
            </li>
            <li>
              <p className="lato-regular">
                A statement that you have a good faith belief that the use of
                the copyrighted work is not authorized by the copyright owner,
                its agent, or the law.
              </p>
            </li>
            <li>
              <p className="lato-regular">
                A statement by you UNDER PENALTY OF PERJURY that the information
                in your notice is accurate and that you are the copyright owner
                or authorized to act on the copyright owner's behalf.
              </p>
            </li>
            <li>
              <p className="lato-regular">
                Your electronic or physical signature.
              </p>
            </li>
          </ol>

          <p className="lato-regular">You may submit this information via:</p>

          <ul>
            <li>
              <p className="lato-regular">
                Email:{' '}
                <strong>
                  <a href="mailto:copyright@twine.net">copyright@twine.net</a>
                </strong>
              </p>
            </li>
            <li>
              <p className="lato-regular">
                Offline:{' '}
                <strong>
                  <a href="#copyright-agent">Copyright Agent</a>
                </strong>
              </p>
            </li>
          </ul>

          <h3 className="lato-bold mt mb">
            Filing a Counter-notification to Restore Removed Content - for Twine
            Users
          </h3>

          <p className="lato-regular">
            The counter-notification process may only be pursued in instances
            where the upload was removed or disabled as a result of a mistake or
            misidentification of the material to be removed or disabled, such as
            fair use. It should not be pursued under any other circumstances.
          </p>

          <p className="lato-regular">
            Counter notifications must be submitted by the original Content
            uploader or an agent authorized to act on their behalf, such as an
            attorney. To submit a counter notification
            {/* , please use our webform by any project
            that is flagged as copyright infringement.
          </p>

          <p className="mb++ mt++ text-center">
            <a className="btn btn-primary btn-lg" href="/copyright/report">
              <Icon icon="&#xf02d;" /> Report copyright infringement
            </a>
          </p>

          <p className="lato-regular">
            You may also*/}{' '}
            contact us by e-mail or by traditional mail. Provide Twine with a
            written counter-notification containing the following information:
          </p>

          <ol>
            <li>
              <p className="lato-regular">
                Your name, address, telephone number, and e-mail address.
              </p>
            </li>
            <li>
              <p className="lato-regular">
                A description of the material that was removed and the location
                on Twine (e.g., the URL) where it previously appeared.
              </p>
            </li>
            <li>
              <p className="lato-regular">
                A statement UNDER PENALTY OF PERJURY that you have a good faith
                belief that the material was removed or disabled as a result of
                mistake or misidentification.
              </p>
            </li>
            <li>
              <p className="lato-regular">
                A statement that you consent to the jurisdiction of English
                courts, and that you will accept service of process from the
                person who filed the original notice or an agent of that person.
              </p>
            </li>
            <li>
              <p className="lato-regular">
                Your electronic or physical signature.
              </p>
            </li>
          </ol>

          <p className="lato-regular">You may submit this information via:</p>

          <ul>
            <li>
              <p className="lato-regular">
                Email:{' '}
                <strong>
                  <a href="mailto:copyright@twine.net">copyright@twine.net</a>
                </strong>
              </p>
            </li>
            <li>
              <p className="lato-regular">
                Offline:{' '}
                <strong>
                  <a href="#copyright-agent">Copyright Agent</a>
                </strong>
              </p>
            </li>
          </ul>

          <p className="lato-regular">
            Please note that we will send any complete counter-notifications we
            receive to the person who submitted the original notice. That person
            may elect to file a lawsuit against you for copyright infringement.
            If we do not receive notice that a lawsuit has been filed within ten
            (10) business days after we provide notice of your
            counter-notification, we will restore the removed materials. Until
            that time, your materials will remain removed.
          </p>

          <h3 className="lato-bold mt mb">Repeat Infringer Policy</h3>

          <p className="lato-regular">
            Twine will terminate user accounts that have been the subject of
            three (3) separate notices. In the event a user's materials are
            removed due to a notice and then subsequently restored due to the
            filing of a counter-notification, Twine will treat the underlying
            notice as withdrawn.
          </p>

          <p className="lato-regular">
            Twine reserves the right to terminate user accounts that are the
            subject of fewer than three (3) notices in appropriate
            circumstances, such as where the user has a history of violating or
            willfully disregarding Twine's Terms of Service.
          </p>

          <h3 className="lato-bold mt mb">Warning</h3>

          <p className="lato-regular">
            In filing a notice or counter-notification, please make sure that
            you have complied with all of the above requirements. If we request
            additional information necessary to make your notice or
            counter-notification complete, please provide that information
            promptly. If you fail to comply with all of these requirements, your
            notice or counter-notification may not be processed further.
          </p>

          <p className="lato-regular">
            In addition, please make sure that all of the information you
            provide is accurate. Twine may disclose any communications
            concerning these notices or other intellectual property complaints
            with third parties, including the users who have posted the
            allegedly infringing material.
          </p>

          <a name="copyright-agent"></a>
          <h3 id="copyright-agent" className="lato-bold mt mb">
            Twine's Copyright Agent
          </h3>

          <p className="lato-regular">
            You may send a notice, a counter-notification, or any inquiries
            concerning intellectual property to Twine's Copyright Agent:
          </p>

          <p className="lato-regular">
            <address>
              <p className="lato-regular">
                Attn: Legal - Copyright Department
                <br />
                Twine
                <br />
                Parsonage Chambers 3 Parsonage
                <br />
                Manchester
                <br />
                M3 2HW
                <br />
                UK
              </p>
            </address>
          </p>

          <hr />

          <p className="lato-regular">
            For further terms of using Twine, please read our{' '}
            <a href="/terms">Terms and Conditions</a>.
          </p>
        </div>
      </div>
    );
  }
}
